export default __webpack_public_path__ + "static/media/bg_full.235d86d8.svg";